import { Injectable } from '@angular/core';

/** Default dropdown configuration */
@Injectable()
export class BsDropdownConfig {
  /** default dropdown auto closing behavior */
  autoClose = true;
}



// WEBPACK FOOTER //
// ./src/app/typescripts/free/dropdown/dropdown.config.ts